import { cva } from 'class-variance-authority';
import { useEffect } from 'react';
import Button from './Button.jsx';

const modal = cva('modal', {
    variants: {
        open: {
            true: ['--open'],
        },
    },
    defaultVariants: {
        open: false,
    },
});

const Modal = ({ isOpen, title, message, action, fn }) => {
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27 && isOpen) {
                fn.handleButton('modal.close');
            }
        };

        if (isOpen) {
            window.addEventListener('keydown', handleEsc);
        }

        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, [isOpen]);

    return (
        <div className={modal({ open: isOpen }, 'modal')}>
            <div className="modal-content">
                <div className="modal-header">
                    <h2 className="mb-0">{title}</h2>
                </div>
                <div className="modal-body" dangerouslySetInnerHTML={{ __html: message }}></div>
                <div className="modal-footer">
                    <Button title="Zavřít okno" type="primary" onClick={() => fn.handleAction(action)} />
                </div>
            </div>
        </div>
    );
};

export default Modal;
